import {messageConst} from '../constants';

const initialState = {};

export function messageRedu(state = initialState, action) {
  switch (action.type) {
    case messageConst.GET_ALL_SUCCESS:
      return {
        type: action.type,
        messages: action.messages
      };
    case messageConst.GET_ONE_SUCCESS:
    case messageConst.CREATE_SUCCESS:
    case messageConst.UPDATE_SUCCESS:
      return {
        type: action.type,
        message: action.message
      };
    case messageConst.DELETE_SUCCESS:
      return {
        type: action.type,
        message: {}
      };

    case messageConst.GET_ALL_FAILURE:
    case messageConst.GET_ONE_FAILURE:
    case messageConst.CREATE_FAILURE:
    case messageConst.UPDATE_FAILURE:
    case messageConst.DELETE_FAILURE:
      return {
        type: action.type,
        error: action.error
      };
    default:
      return state;
  }
}